import { render } from "./StateBoarding.vue?vue&type=template&id=ca3f5a22&scoped=true"
import script from "./StateBoarding.vue?vue&type=script&lang=js"
export * from "./StateBoarding.vue?vue&type=script&lang=js"

import "./StateBoarding.vue?vue&type=style&index=0&id=ca3f5a22&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3f5a22"]])

export default __exports__